const defaults = {
    currency : {
        base : "GBP"
    },
    formatter : {
        GBP : new Intl.NumberFormat('en-UK', {
            style: 'currency',
            currency: 'GBP',
            minimumFractionDigits: 2
        }),
        USD : new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        })
    }
};

const getCountry = () => window.localStorage.getItem( 'site_of_origin' ) || 'gb' ;
const taxType = () => getCountry() === 'gb' ? 'VAT' : 'TAX' ;

function format( value = 0, country ){
    switch( country || getCountry() ){
        case "gb":
            return defaults.formatter.GBP.format( value );
        case "us":
            return defaults.formatter.USD.format( value );
    };
};

function convert( value = 0, country ){
    // clean if string
    value = typeof value !== 'string' ? value : +value.replace( new RegExp('[+]', 'g'), '' ).replace( '£', '' ).replace( new RegExp(',', 'g'), '' ).trim();
    return format( value, country );
};

export {
    format,
    convert,
    taxType
};



// WEBPACK FOOTER //
// src/client/helpers/common/currency.js